import React from 'react';
import Icon from '../../../components/AppIcon';

const ExecutiveAlertPanel = ({ alerts, onViewAll }) => {
  const getSeverityStyles = (severity) => {
    switch (severity) {
      case 'critical':
        return {
          bg: 'bg-error/10',
          text: 'text-error',
          border: 'border-error/20',
          icon: 'AlertTriangle'
        };
      case 'high':
        return {
          bg: 'bg-warning/10',
          text: 'text-warning',
          border: 'border-warning/20',
          icon: 'AlertCircle'
        };
      default:
        return {
          bg: 'bg-muted',
          text: 'text-muted-foreground',
          border: 'border-border',
          icon: 'Info'
        };
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-base text-foreground mb-1">
            Critical Alerts
          </h3>
          <p className="caption text-xs text-muted-foreground">
            Issues requiring board attention
          </p>
        </div>
        <button
          onClick={onViewAll}
          className="text-xs text-primary hover:underline"
        >
          View All
        </button>
      </div>

      <div className="space-y-3">
        {alerts?.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <Icon name="CheckCircle" size={32} color="var(--color-success)" className="mb-2" />
            <p className="text-sm text-muted-foreground">No critical alerts</p>
          </div>
        ) : (
          alerts?.map((alert, index) => {
            const styles = getSeverityStyles(alert?.severity);
            return (
              <div
                key={index}
                className={`${styles?.bg} border ${styles?.border} rounded-lg p-3 transition-smooth hover:shadow-sm`}
              >
                <div className="flex items-start gap-3">
                  <Icon name={styles?.icon} size={18} color={`var(--color-${alert?.severity === 'critical' ? 'error' : 'warning'})`} />
                  <div className="flex-1">
                    <h4 className={`text-sm font-medium ${styles?.text} mb-1`}>
                      {alert?.title}
                    </h4>
                    <p className="text-xs text-muted-foreground mb-2">
                      {alert?.message}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-muted-foreground">
                        {formatDate(alert?.createdAt)}
                      </span>
                      <span className={`text-xs font-medium ${styles?.text} uppercase`}>
                        {alert?.severity}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ExecutiveAlertPanel;